// "Comprobante emitido": el cuadro con Imprimir / Descargar PDF / Listo no
// puede vivir dentro del panel de cobro — ese panel se cierra solo cuando el
// refresco automático (cada 10 s) ve que la cuenta ya está pagada, y el cuadro
// desaparecía antes de que el cajero hiciera algo. Se muestra desde el layout
// (siempre montado) y guarda una copia de los pedidos y la cuenta, que para
// entonces ya están cerrados.
let current = null;
const listeners = new Set();

export function showIssuedDocument(payload) {
  current = payload;
  listeners.forEach((listener) => listener(current));
}

export function closeIssuedDocument() {
  current = null;
  listeners.forEach((listener) => listener(current));
}

export function subscribeIssuedDocument(listener) {
  listeners.add(listener);
  listener(current);
  return () => listeners.delete(listener);
}
